module.exports = __webpack_public_path__ + "static/positive8-ce770ced756f7d31261bc3f059bef796.mp3";